/* ------------------------------------------------------------------
 *  返信画面確認の各イベント生成に関する処理
--------------------------------------------------------------------- */
const postReplyEvents = (via_public_url = false) => {
  const path = location.pathname;
  const idStartPosition = path.indexOf("/replies") + "/replies".length + 1;
  const replyId = path.slice(idStartPosition); // 'URLの:id部分のみ取得（via_public_urlの場合は:tokenが入る）

  const selectCsrfToken = () =>
    document.querySelector('meta[name="csrf-token"]').content;

  const createReplyEvent = (eventType) => {
    const param = { event_type: eventType };
    const url = via_public_url
      ? Routes.public_reply_events_path(replyId)
      : Routes.people_reply_events_path(replyId);
    fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": selectCsrfToken(),
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(param),
    });
  };

  $(".jsMailtoLink").on("click", () => {
    createReplyEvent("mailto_link_first_clicked");
  });
  $(".jsMailtoLink").on("copy", () => {
    createReplyEvent("mailto_link_first_copied");
  });

  $("#jsMailtoCopy").on("click", () => {
    const mailtoText = $(".mailTo").text();
    navigator.clipboard.writeText(mailtoText).then(
      () => {
        toastr.success("返信先アドレスをコピーしました");
        createReplyEvent("mailto_link_first_copied");
      },
      () => {}
    );
  });
};

// NOTE: esbuild はモジュールレベルの副作用がない純粋な関数宣言をバンドルから除外する
// Sprockets からの移行のため、グローバルアクセスを維持するために window に公開する

export default postReplyEvents;